import { action, makeObservable, observable } from 'mobx';
import { GaPageLabel } from '../services/AnalyticsService';

export interface IModalStore {
  readonly activeModal: ModalType;
  gaPageLabel: GaPageLabel;

  closeModal(): void;
  openModal(modalName: ModalType, modalGaPageLabel?: string): void;
}

export class ModalStore implements IModalStore {
  @observable
  public activeModal: ModalType = null;
  public gaPageLabel: GaPageLabel;

  public constructor() {
    makeObservable(this);
  }

  @action
  public closeModal(): void {
    this.activeModal = null;
  }

  @action
  public openModal(modalType: ModalType, modalGaPageLabel?: GaPageLabel): void {
    this.setGaPageLabel(modalGaPageLabel || 'invoices');
    this.activeModal = modalType;
  }

  @action
  public setGaPageLabel(pageLabel: GaPageLabel): void {
    this.gaPageLabel = pageLabel;
  }
}

export enum ModalType {
  InvoiceSettingsModal,
  InvoicePaymentModal,
  PayAllInvoicesPaymentModal,
  PrepaymentPaymentModal,
  PosPaymentModal,
  ProductCurrentBalanceModal,
  InvoiceDetailsModal,
  InvoiceLineUsagesModal
}
